import { colors } from 'constants/colorsBase';
import { useState, useCallback } from 'react';
import { ESettingTimer, ETimeShift, ETimeShiftFormat, ETimeShiftKeys } from 'constants/constants';
import { IStaff, ITimeAttendance } from '@pages/CompanySite/AttendanceRecord/interface';
import { responseSuccess } from 'helper/responseSuccess/responseSuccess';
import { apiAdminSetTimeAttendance } from 'api/company';

import { Dayjs } from 'dayjs';
import { checkCanChangeByRootAdmin, checkOverDate } from 'helper/attendanceRecord';
import { useNavigate } from 'react-router-dom';
import { ERROR_CODE_COMMON, VALIDATE_ERROR_CODE } from 'constants/errorCode';
import { message } from 'antd';
import { CONST_ATTENDANCE_COMPANY } from 'constants/language';
// import { COMPANY_LIST_STAFF_ATTENDANCE } from 'constants/keyQuery';
// import { useQueryClient } from 'react-query';
export const checkTextConfirm = (changing: any, _changeData: any, setTextConfirm: any) => {
  if (changing === ETimeShiftKeys.DAY_SHIFT) {
    if (_changeData.salary_type === 2 || _changeData.salary_type === 1) {
      if (_changeData.day_shift === ETimeShift.NOT_ACTIVITY) {
        setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_CANCEL_MODAL_CONFIRM);
      } else {
        setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_MODAL_CONFIRM);
      }
    }
    if (_changeData.salary_type === 3) {
      if (_changeData.morning_working_time_shift_time === ETimeShift.NOT_ACTIVITY) {
        setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_CANCEL_MODAL_CONFIRM);
      } else {
        setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_MODAL_CONFIRM);
      }
    }
  }
  if (changing === ETimeShiftKeys.NIGHT_SHIFT) {
    if (_changeData.salary_type === 2 || _changeData.salary_type === 1) {
      if (_changeData.night_shift === ETimeShift.NOT_ACTIVITY) {
        setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_CANCEL_MODAL_CONFIRM);
      } else {
        setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_MODAL_CONFIRM);
      }
    }
    if (_changeData.salary_type === 3) {
      if (_changeData.afternoon_working_time_shift_time === ETimeShift.NOT_ACTIVITY) {
        setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_CANCEL_MODAL_CONFIRM);
      } else {
        setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_MODAL_CONFIRM);
      }
    }
  }
  if (changing === ETimeShiftKeys.MORNING_HALF) {
    if (_changeData.morning_haft_shift === ETimeShift.NOT_ACTIVITY) {
      setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_CANCEL_MODAL_CONFIRM);
    } else {
      setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_MODAL_CONFIRM);
    }
  }
  if (changing === ETimeShiftKeys.AFTERNOON_HALF) {
    if (_changeData.afternoon_haft_shift === ETimeShift.NOT_ACTIVITY) {
      setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_CANCEL_MODAL_CONFIRM);
    } else {
      setTextConfirm(CONST_ATTENDANCE_COMPANY.ATTENDANCE_MODAL_CONFIRM);
    }
  }
};

const useAttendanceTable = ({
  currentDate,
  isRootAdmin,
  setAttendanceDetailData,
  attendanceDetailData,
}: {
  currentDate: Dayjs;
  isRootAdmin: boolean;
  setAttendanceDetailData: any;
  attendanceDetailData: any;
}) => {
  // const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowConfirm, setIsShowConfirm] = useState<boolean>(false);
  const [confirmData, setConfirmData] = useState<ITimeAttendance | null>(null);
  const [confirmChanging, setConfirmChanging] = useState<string>('');
  const [textConfirm, setTextConfirm] = useState('');

  const toDetailMember = (idStaff: number) => {
    navigate(`/attendance/detail/${btoa(idStaff.toString())}`);
  };

  const handleAnalysisColorDay = (
    changeData: ITimeAttendance,
    dayShift: ETimeShift.ACTIVITY | ETimeShift.NOT_ACTIVITY,
    bgColorActive: string,
    shift: string,
    forceInActive?: boolean
  ) => {
    const data = {
      color: colors.mainText,
      shadow: colors.shadowAttendance,
      background: colors.white,
    };
    if (dayShift === ETimeShift.ACTIVITY) {
      data.background = bgColorActive;
      data.shadow = 'none';
      data.color = colors.white;
    }

    if (!checkCanChangeByRootAdmin(changeData, shift, currentDate, isRootAdmin) || forceInActive) {
      data.shadow = colors.shadowInsetFor;
    }
    return data;
  };

  const attendanceMemberData = useCallback(
    async (changeData: ITimeAttendance, changing: string) => {
      try {
        const newData = { ...changeData };
        if ((changing === ETimeShiftKeys.DAY_SHIFT || changing === ETimeShiftKeys.NIGHT_SHIFT) && newData[changing]) {
          newData.leave = ETimeShift.NOT_ACTIVITY;
        }
        if (changing === ETimeShiftKeys.LEAVE && newData[changing]) {
          newData.day_shift = ETimeShift.NOT_ACTIVITY;
          newData.night_shift = ETimeShift.NOT_ACTIVITY;
        }
        let _newData = { ...newData };
        if (_newData.morning_haft_shift) {
          _newData.day_shift = ETimeShift.NOT_ACTIVITY;
        }
        if (_newData.afternoon_haft_shift) {
          _newData.night_shift = ETimeShift.NOT_ACTIVITY;
        }
        const response = await apiAdminSetTimeAttendance(_newData);
        if (responseSuccess(response)) {
          // queryClient.refetchQueries(COMPANY_LIST_STAFF_ATTENDANCE);
          let dataResponse = { ...response?.data };
          if (dataResponse.morning_haft_shift) {
            dataResponse.day_shift = ETimeShift.ACTIVITY;
          }
          if (_newData.afternoon_haft_shift) {
            dataResponse.night_shift = ETimeShift.ACTIVITY;
          }
          setAttendanceDetailData(
            attendanceDetailData?.map((element: IStaff) => {
              if (element.staff_id === response?.data?.staff_id) {
                return {
                  ...element,
                  time_attendance: [dataResponse],
                };
              }
              return element;
            })
          );
        } else {
          if (response?.response?.data?.code === VALIDATE_ERROR_CODE.ATTENDANCE_REQUEST_DATE_INVALID) {
            message.error(CONST_ATTENDANCE_COMPANY.ATTENDANCE_REQUEST_DATE_INVALID);
          }
          if (response?.response?.data?.code === VALIDATE_ERROR_CODE.ATTENDANCE_STAFF_DISCONNECTED) {
            message.error(CONST_ATTENDANCE_COMPANY.ATTENDANCE_STAFF_DISCONNECTED);
          }
          if (response?.response?.data?.code === VALIDATE_ERROR_CODE.ATTENDANCE_STAFF_NOT_ALLOW_REQUEST_SALARY) {
            message.error(CONST_ATTENDANCE_COMPANY.ATTENDANCE_STAFF_NOT_ALLOW_REQUEST_SALARY);
          }
          if (
            response?.response?.data?.code === VALIDATE_ERROR_CODE.ATTENDANCE_STAFF_BLOCK ||
            response?.response?.data?.code === VALIDATE_ERROR_CODE.NOT_ACCEPTTABLE_CODE
          ) {
            message.error(CONST_ATTENDANCE_COMPANY.ATTENDANCE_STAFF_BLOCK);
          }
          if (response?.response?.data?.code === VALIDATE_ERROR_CODE.ATTENDANCE_LIFE_CYCLE) {
            message.error(ERROR_CODE_COMMON.company_pair_b2b.D007);
          }
          if (response?.response?.data?.code === VALIDATE_ERROR_CODE.ATTENDANCE_CYCLE_OLD) {
            message.error(ERROR_CODE_COMMON.company_pair_b2b.D008);
          }
          if (response?.response?.data?.code === VALIDATE_ERROR_CODE.ATTENDANCE_WHEN_LEAVE) {
            message.error(ERROR_CODE_COMMON.company_pair_b2b.D009);
          }
        }
      } catch (error) {
        //
      } finally {
        setIsLoading(false);
      }
    },
    [setAttendanceDetailData, attendanceDetailData]
  );

  const handleOkConfirm = useCallback(() => {
    if (!confirmData || !confirmChanging) return;
    setIsLoading(true);
    attendanceMemberData(confirmData, confirmChanging);
    setIsShowConfirm(false);
  }, [confirmChanging, confirmData, attendanceMemberData]);

  const handleCancelConfirm = () => {
    setIsShowConfirm(false);
    setConfirmData(null);
    setConfirmChanging('');
  };

  const changeTime = async (changeData: ITimeAttendance, changing: string, isSetting: number) => {
    let _changeData = { ...changeData };
    if (_changeData.morning_haft_shift) {
      _changeData.day_shift = _changeData.morning_haft_shift;
    }
    if (_changeData.afternoon_haft_shift) {
      _changeData.night_shift = _changeData.afternoon_haft_shift;
    }

    if (isLoading) return;
    if (!checkCanChangeByRootAdmin(_changeData, changing, currentDate, isRootAdmin, isSetting)) return;
    // if current date is over date, show confirm popup
    if (isSetting === ESettingTimer.SETTING_STATIC) {
      if (
        (checkOverDate(currentDate, ETimeShiftFormat.DATE_NOON, false) &&
          (changing === ETimeShiftKeys.DAY_SHIFT ||
            (changing === ETimeShiftKeys.MORNING_HALF && _changeData.morning_haft_shift === 0))) ||
        (checkOverDate(currentDate, ETimeShiftFormat.DATE_NIGHT, false) &&
          (changing === ETimeShiftKeys.NIGHT_SHIFT ||
            (changing === ETimeShiftKeys.AFTERNOON_HALF && _changeData.afternoon_haft_shift === 0)))
      ) {
        checkTextConfirm(changing, _changeData, setTextConfirm);
        setConfirmData(_changeData);
        setConfirmChanging(changing);
        setIsShowConfirm(true);
      } else {
        setIsLoading(true);
        attendanceMemberData(_changeData, changing);
      }
    } else {
      if (
        (checkOverDate(currentDate, ETimeShiftFormat.DATE_NIGHT, false) &&
          (changing === ETimeShiftKeys.DAY_SHIFT ||
            (changing === ETimeShiftKeys.MORNING_HALF && _changeData.morning_haft_shift === 0))) ||
        (checkOverDate(currentDate, ETimeShiftFormat.DATE_NIGHT, false) &&
          (changing === ETimeShiftKeys.NIGHT_SHIFT ||
            (changing === ETimeShiftKeys.AFTERNOON_HALF && _changeData.afternoon_haft_shift === 0)))
      ) {
        checkTextConfirm(changing, _changeData, setTextConfirm);
        setConfirmData(_changeData);
        setConfirmChanging(changing);
        setIsShowConfirm(true);
      } else {
        setIsLoading(true);
        attendanceMemberData(_changeData, changing);
      }
    }
  };

  return {
    handleAnalysisColorDay,
    changeTime,
    isLoading,
    toDetailMember,
    handleOkConfirm,
    handleCancelConfirm,
    isShowConfirm,
    setIsShowConfirm,
    confirmData,
    confirmChanging,
    textConfirm,
  };
};

export default useAttendanceTable;
